<template>
    <div>
    <v-card
        class="mx-auto mt-4"
        max-width="95%"
        elevation="2"
    >
    <v-toolbar
        color="#37474F"
        dark
    >
    
    <v-toolbar-title>라이브중인 유투브</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn
            color="cyan"
            small
            fab
            @click="ShowPopup_RegistYoutube"
        >
            <v-icon 
            color= "white"
            >mdi-plus</v-icon>
        </v-btn>  

    </v-toolbar>

    <v-list two-line>
    <v-list-item-group        
        active-class="pink--text"
        multiple
    >
    <v-data-table         
        :footer-props="{'items-per-page-options':[20, 50, -1]}"
        :headers="headers" 
        :items="youtube_list"
        :loading="loadingData"
        >        
        <template v-slot:item="row">            
            <tr>
            <!-- <td><img :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+row.item.THUMB_IMG" alt="Image"  style="width: 60px; height: 60px; order: 2px solid black; border-radius: 10px; margin-top: 5px;"></td> -->
            <td>{{row.item.PID}}</td>
            <!-- <td>{{row.item.YT_THUMB}}</td> -->
            <td><img :src="row.item.YT_THUMB" alt="Image"  style="width: 80px; height: 60px; order: 2px solid black; border-radius: 10px; margin-top: 5px;"></td>
            <td :title="row.item.YT_TITLE">{{ row.item.YT_TITLE && row.item.YT_TITLE.length > 12 ? row.item.YT_TITLE.substring(0, 12) + '…' : row.item.YT_TITLE }}</td>
            <td>{{row.item.USER_ID}}</td>
            <td>{{row.item.YT_VIEW_COUNT}}</td>
            <td>{{row.item.YT_LIKE_COUNT}}</td>
            <td>{{row.item.YT_COMMENT_COUNT}}</td>
            <td>https://www.youtube.com/watch?v={{row.item.YT_VIDEO_ID}}</td>
            <td>
                <v-chip
                    :color="row.item.ACTIVATE === 'Y' ? 'blue' : 'red'"
                    dark
                    small
                >
                    {{ row.item.ACTIVATE === 'Y' ? '활성' : '비활성' }}
                </v-chip>
            </td>
            <td>
                <v-btn
                color="indigo"
                class='white--text'
                small
                @click="OnClick_ShowPopup_EditYoutube(row.item)">수정</v-btn>
            </td>                    
            </tr>
        </template>
    </v-data-table>
        </v-list-item-group>
    </v-list>
    </v-card>
    <v-dialog
      v-model="dialog_report_popup"
      max-width="600"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card>
        <v-card-title class="text-h5 mb-3">
          {{'영상 등록하기'}}
        </v-card-title>
        <v-card-text>
    <v-row>
        <v-col cols="1"></v-col>
        <v-col cols="10">이미 등록된 영상의 경우 추가로 등록은 되지 않습니다.</v-col>
    </v-row>
    <v-row >
        <v-col cols="4"  class="text-center font-weight-bold text-h6">유투브 태그</v-col>
        <v-col>
            <v-text-field 
                label="유투브 태그 등록"
                v-model="dialog_regist_youtube_tag" 
                outlined
                dense
            ></v-text-field>
        </v-col>
    </v-row>
    <v-row >
        <v-col cols="4"  class="text-center font-weight-bold text-h6">유저 아이디</v-col>
        <v-col>
            <v-text-field 
                label="영상을 올린 유저 아이디를 입력해주세요"
                v-model="dialog_regist_user_id" 
                outlined
                dense
            ></v-text-field>
        </v-col>
    </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="OnClick_ClosePopup"
          >
            취소
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="OnClick_Regist_Youtube"
          >
            등록하기
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
      v-model="dialog_popup"
      max-width="600"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card>
        <v-card-title class="text-h5 mb-3">
          {{'영상 수정하기'}}
        </v-card-title>
        <v-card-text>
        <v-row>
            <v-col cols="1"></v-col>
            <v-col cols="10">이미 등록된 영상의 경우 추가로 등록은 되지 않습니다.</v-col>
        </v-row>
        <v-row >
            <v-col cols="4"  class="text-center font-weight-bold text-h6">유저 아이디</v-col>
            <v-col>
                <v-text-field 
                    label="영상을 올린 유저 아이디를 입력해주세요"
                    v-model="dialog_regist_user_id" 
                    outlined
                    dense
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row >
            <v-col cols="4"  class="text-center font-weight-bold text-h6">활성 / 비활성</v-col>
            <v-col>
            <v-switch
            v-if="dialog_selected_youtube_item"
            v-model="dialog_selected_youtube_item._activate_switch"
            @change="val => dialog_selected_youtube_item.activate = val ? 'Y' : 'N'"
            inset
            ></v-switch>
            </v-col>
        </v-row>


        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="OnClick_ClosePopup"
          >
            취소
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="OnClick_Edit_Youtube"
          >
            등록하기
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>    
    
</template>

<script>
import { mapActions } from 'vuex';
import config from '../../config/config';
const { s3_upload , FileUpload_Async ,  FileUpload_JSON} = require("../../util/fileutil");
export default {
    name: 'UserList',

    data: () => ({
        loadingData:false,

        items :[{title:'USER_ID',
        subtitle:'닉네임',
        action:'우편' }],
        headers_report: [            
            { text: '신청자', value: 'user' },
            { text: '링크', value: 'name' },
            { text: '신청일', value: 'date' },
            { text: '확인여부', value: 'enable' },
            { text: '처리', value: 'kw_price' },            
        ],

        headers: [
            { text: '고유아이디', value: 'icon', width: '70px' },
            { text: '썸네일', value: 'name', width: '90px' },
            { text: '이름', value: 'name', width: '130px' },
            { text: '유저아이디', value: 'name', width: '100px' },
            { text: '조회수', value: 'name', width: '70px' },
            { text: '좋아요수', value: 'name', width: '70px' },
            { text: '댓글수', value: 'name', width: '70px' },
            { text: '링크보기', value: 'link', width: '280px' },
            { text: '상태', value: 'enable', width: '70px' },
            { text: '수정', value: 'enable', width: '80px' },
        ],
        youtube_list:[],
        youtube_report_list:[],

        total_count:0,
        dialog_report_popup: false ,


        

        dialog_selected_report_item: {},
        dialog_selected_youtube_item: null,
        dialog_popup:false ,
        dialog_regist_user_id:'',
        dialog_regist_youtube_tag:'',   
        dialog_dropdown_selected:null,


    }),

    created()
    {
        console.log("TEST");
        this.Load_YoutubeList();
        this.Load_Youtube_ReportList();
    },

    methods:{
        ...mapActions([
            'CPU_GET_YOUTUBE_VIDEO_INFO',
            'CPU_REGIST_YOUTUBE_VIDEO_INFO',
            'CPU_EDIT_YOUTUBE_VIDEO_INFO',
            'CPU_GET_YOUTUBE_REPORT_INFO',
            'CPU_EDIT_YOUTUBE_REPORT_INFO'
        ]),
  
        ShowPopup_RegistYoutube()
        {
            this.dialog_regist_youtube_tag = '';
            this.dialog_regist_user_id = '';
            this.dialog_report_popup = true;
        },
        Load_YoutubeList()
        {
            this.CPU_GET_YOUTUBE_VIDEO_INFO({}).then((body_data)=>{
                 //console.log("CPU_GET_YOUTUBE_VIDEO_INFO");
                this.youtube_list = body_data.queryResult;
                //console.log(JSON.stringify(body_data.queryResult));
            });
        },
        Load_Youtube_ReportList() {
         this.CPU_GET_YOUTUBE_REPORT_INFO({}).then((body_data) => {
            this.youtube_report_list = body_data.queryResult.map(item => ({
            ...item,
            // ✅ 키 통일
            activate: item.ACTIVATE, // ACTIVATE → activate 로 복사
            _activate_switch: item.ACTIVATE === 'Y', // 여기서도 ACTIVATE 기준
            }));
        });
        },
  
        OnClick_ShowPopup_EditReport(item)
        {
            this.dialog_selected_report_item = item;
            this.dialog_popup = false;
            this.dialog_report_popup = true;
        },
        OnClick_Regist_Youtube(){
            
            this.dialog_report_popup = false;
            let yt_video_id = this.dialog_regist_youtube_tag;
            // const match = yt_video_link.match(/(?:v=|\/embed\/|\/v\/|youtu\.be\/)([A-Za-z0-9_-]{11})/);
            // if (match && match[1]) {
            //     yt_video_id = match[1];
            // }            
            // const match = yt_video_link.match(/(?:v=|\/embed\/|\/v\/|youtu\.be\/|\/shorts\/)([A-Za-z0-9_-]{11})/);
            // if (match && match[1]) {
            //     yt_video_id = match[1];
            // }
            let comment = '';
            let user_id = this.dialog_regist_user_id;
            if(yt_video_id =='' || user_id ==''){
                alert('유투브 태그와 유저 아이디를 모두 입력해주세요');
                this.dialog_report_popup = true;
                return;
            }   
            this.CPU_REGIST_YOUTUBE_VIDEO_INFO({yt_video_id,comment, user_id}).then((body_data)=>{
                 console.log("CPU_GET_YOUTUBE_REPORT_INFO" + JSON.stringify(body_data));
                 if(body_data?.state =='duplicate' ){
                    alert('이미 등록된 영상입니다');
                    this.dialog_report_popup = false;
                    return;
                 }else{
                    //this.$toast.success('영상이 등록되었습니다.');
                    alert('영상이 등록되었습니다.');
                    this.dialog_report_popup = false;
                    this.Load_YoutubeList();
                    this.Load_Youtube_ReportList();
                 }
                // this.youtube_report_list = body_data.queryResult;
                // console.log(JSON.stringify(body_data.queryResult));
            });
            
        },
        OnClick_ClosePopup()
        { 
            this.dialog_report_popup = false;
            this.dialog_popup = false;
        },
        handleFileChange(file)
        {
            this.dialog_IconImageFile = file;            
        },
        Utill_CreateNewImageName(originalFileName)
        { // 확장자 추출
            const fileExtension = originalFileName.substring(originalFileName.lastIndexOf('.')); // 예: ".png", ".jpg"
            // 랜덤 문자열 생성 (16자)
            const randomString = Math.random().toString(36).substring(2, 18); // 예: "5g8n4z6qx0ld3y7w"
            // 새 파일 이름 생성
            return randomString + fileExtension; // 예: "5g8n4z6qx0ld3y7w.png"
        },
        OnClick_MoveYoutube_EditReport(item)
        {
            this.dialog_selected_report_item = item;
            this.dialog_popup = false;
            this.dialog_report_popup = true;
        },
        Save_ReportChange_ActiveState(item){
            const pid = item.PID;
            const activate = item.activate;   // ✅ activate로 보내기
            const comment = '상태변경';
            console.log("JSJS : " + activate);
            this.CPU_EDIT_YOUTUBE_REPORT_INFO({ pid, activate, comment }).then(() => {
                this.Load_Youtube_ReportList();
            });
        },
        OnClick_ShowPopup_EditYoutube(item){
            //this.dialog_selected_youtube_item = item;
            console.log(JSON.stringify(item));
            //this.dialog_selected_youtube_item.activate = item.ACTIVATE == 'Y' ? true : false;
            this.dialog_selected_youtube_item = {
                ...item,
                activate: item.ACTIVATE,
                _activate_switch: item.ACTIVATE === 'Y',
            };
            this.dialog_popup = true;
            this.dialog_regist_user_id = item.USER_ID;
        },
        OnClick_Edit_Youtube(){
            this.dialog_popup = false;
               
               let pid = this.dialog_selected_youtube_item.PID;
               let  comment = '';
               let user_id  = this.dialog_regist_user_id;
               let activate = this.dialog_selected_youtube_item.activate;         
               console.log("JSJS ---> Activate Check : " + JSON.stringify(this.dialog_selected_youtube_item));   
               console.log("JSJS ---> Activate Check : " + activate);   
               this.CPU_EDIT_YOUTUBE_VIDEO_INFO({ pid , comment, user_id , activate}).then((body_data)=>{
                    this.dialog_popup = false;
                    this.Load_YoutubeList();
                    this.Load_Youtube_ReportList();
            });
        },
        handleSwitchChange(item, val) {
            //item.activate = val ? 'Y' : 'N';
            item.activate = val ? 'Y' : 'N';        // ✅ 내부 로직은 activate 사용
            item._activate_switch = val;

            this.Save_ReportChange_ActiveState(item);
            //this.Load_Youtube_ReportList();
        },
    },
    computed: {
    },


    components:{
    },
    watch :{
    }
};
</script>

<style scoped>
@media (max-width: 600px) {
  .v-data-table { overflow-x: auto; }
  .v-toolbar__content { flex-wrap: wrap; height: auto !important; padding: 8px; }
}
</style>
